var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.supportingData.length)?_c('SupportingData',{staticClass:"tw-my-1 !tw-gap-2 tw-border-y tw-border-dusty-gray-500 !tw-text-[0.65rem] !tw-leading-[0.75rem]",attrs:{"data":_vm.supportingData,"max-num-of-elements":7}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }